export default __webpack_public_path__ + "static/media/main3(2).4f25cdce.png";